module.exports = __webpack_public_path__ + "img/my-type.45add965.png";